var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"80vmin","overlay-opacity":"0.9"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-img',_vm._g(_vm._b({staticClass:"rounded-xl",staticStyle:{"box-shadow":"#80d8ff 0 0 5px"},attrs:{"src":_vm.src,"width":_vm.size,"height":_vm.size}},'v-img',attrs,false),on))]}}])},[_c('v-img',{attrs:{"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }